import React, { useEffect, useState } from "react";
import { AppShell } from "@/components/AppShell";
import { api } from "@/lib/api";
import { Sparkles, ShieldCheck } from "lucide-react";

export default function AIInsights() {
  const [agents, setAgents] = useState([]);
  const [recos, setRecos] = useState([]);

  useEffect(() => {
    api.get("/ai/agents").then((r) => setAgents(r.data)).catch(() => {});
    api.get("/ai/recommendations").then((r) => setRecos(r.data)).catch(() => {});
  }, []);

  return (
    <AppShell title="ILLAM AI">
      <div className="bg-[#3E3E3E] text-[#F5F2EB] rounded-lg p-5 mb-6 flex items-start gap-3">
        <ShieldCheck className="text-[#F56B1F] shrink-0" size={22} />
        <div>
          <h2 className="font-heading font-semibold">Governed AI foundation</h2>
          <p className="text-sm text-[#b9b3a6] mt-1 max-w-2xl">Every agent runs inside the same RBAC and tenant boundary as the invoking user. Effective permission = User + Agent + Action. AI can observe, analyse and recommend — it can never approve, commit price, or bypass a permission.</p>
        </div>
      </div>

      <h3 className="font-heading text-base font-semibold text-neutral-900 mb-3">Registered Agents</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {agents.map((a) => (
          <div key={a.id} data-testid={`ai-agent-${a.code}`} className="bg-white rounded-lg border border-[#D7C6A9] p-4 hover:shadow-[0_2px_12px_rgba(0,0,0,0.06)] transition-shadow">
            <div className="flex items-center gap-2.5 mb-2">
              <div className="h-9 w-9 rounded-md bg-[#EEE9DE] flex items-center justify-center"><Sparkles size={17} className="text-[#F56B1F]" /></div>
              <div><div className="text-sm font-semibold text-neutral-900">{a.name}</div><div className="text-[11px] mono text-neutral-400">{a.code}</div></div>
            </div>
            <p className="text-xs text-neutral-500 leading-relaxed">{a.description}</p>
            <div className="flex flex-wrap gap-1.5 mt-3">
              {a.capabilities.map((c) => <span key={c} className="text-[10px] uppercase tracking-wider bg-[#EEE9DE] text-neutral-600 px-2 py-0.5 rounded">{c}</span>)}
            </div>
          </div>
        ))}
      </div>

      <h3 className="font-heading text-base font-semibold text-neutral-900 mt-8 mb-3">Recommendations</h3>
      <div className="bg-white rounded-lg border border-[#D7C6A9] p-8 text-center text-sm text-neutral-400" data-testid="ai-recommendations-empty">
        {recos.length === 0 ? "No AI recommendations yet — agents populate these once their modules go live." : `${recos.length} recommendations`}
      </div>
    </AppShell>
  );
}
